import React, { FC, useState } from "react";
import { Button, Table, message, Upload, Modal, Input } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { useOfferDetailModel } from "../offerDetailModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { IOfferMaterialDetail, IOfferDetail } from "../../../offerTypes";
import { formatNum, formatInt } from "@/utils/utils";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useOfferModel } from "../../../offerModel";
import { importPropsConfig1 } from "@/utils/importFile1";
import { offerService } from "../../../offerService";
import { enquiryService } from "@/views/inquires/enquiry/enquiryService";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        addList,
        editList,
        editFormVal,
        addFormVal,
        addDesc, editDesc,
        updateList,
        removeMaterial,
        setMaterialDialog,
        materialExportExcel,
        getcurrencySymbol,
        isDisabeld, downloadSupplierTpl,
        getOfferDetailOneGoods,
    } = useOfferDetailModel(({ addList, editList, addDesc, editDesc }) => [addList, editList, addDesc, editDesc]);
    const { downloadDetailTpl } = useOfferModel()
    const tableList = mode === "edit" ? editList : addList;
    const formVal: IOfferDetail = mode === "edit" ? editFormVal : addFormVal;
    const desc = mode === "edit" ? editDesc : addDesc;
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

    const columns = [
        {
            title: '序号',
            width: 45,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '商品编码',
            width: 160,
            fixed: "left",
            dataIndex: 'materialCode',
        }, {
            title: '商品名称',
            width: 160,
            fixed: "left",
            dataIndex: 'materialName',
        }, {
            title: '商品名称-英文',
            width: 160,
            fixed: "left",
            dataIndex: 'materialEname',
        }, {
            title: '商品类型',
            width: 160,
            dataIndex: 'typeName',
        }, {
            title: '*数量',
            width: 160,
            dataIndex: 'num',
            editable: true
        }, {
            title: '采购单价',
            width: 160,
            dataIndex: 'price',
            editable: true,
            render: (text: any) => text === "null" ? "" : `￥${formatNum(text)}`,
        }, {
            title: '采购总金额',
            width: 160,
            dataIndex: 'amount',
            // editable: true,
            render: (text: any) => `￥${formatNum(text)}`,
        }, {
            title: '规格',
            width: 160,
            dataIndex: 'model',
        }, {
            title: '单位',
            width: 120,
            dataIndex: 'unitName',
        }, {
            title: '海关编码',
            width: 100,
            dataIndex: 'customsCode',
        }, {
            //     title: '欧豪销售单价',
            //     width: 160,
            //     dataIndex: 'auhowPrice',
            //     editable: true,
            //     render: (text: any) => text === "null" ? "" : `￥${formatNum(text)}`,
            // }, {
            //     title: '欧豪销售总价',
            //     width: 160,
            //     dataIndex: 'auhowAmount',
            //     editable: true,
            //     render: (text: any) => `￥${formatNum(text)}`,
            // }, {
            //     title: '上浮单价',
            //     width: 160,
            //     dataIndex: 'upPrice',
            //     editable: true,
            //     render: (text: any) => text === "null" ? "" : `￥${formatNum(text)}`,
            // }, {
            //     title: '上浮总金额',
            //     width: 160,
            //     dataIndex: 'upAmount',
            //     editable: true,
            //     render: (text: any) => `￥${formatNum(text)}`,
            // }, {
            //     title: '退税金额',
            //     width: 160,
            //     dataIndex: 'drawbackAmount',
            //     editable: true,
            //     render: (text: any) => text === "null" ? "" : `￥${formatNum(text)}`,
            // }, {
            //     title: '云湖销售单价(人民币)',
            //     width: 160,
            //     dataIndex: 'salePrice',
            //     editable: true,
            //     render: (text: any) => text === "null" ? "" : `￥${formatNum(text)}`,
            // }, {
            //     title: '云湖销售总价(人民币)',
            //     width: 160,
            //     dataIndex: 'saleAmount',
            //     editable: true,
            //     render: (text: any) => `￥${formatNum(text)}`,
            // },
            // ...(function (isMiddleman?: boolean | string) {
            //     return isMiddleman === "1" ? [
            //         {
            //             title: '云泰单价',
            //             width: 160,
            //             dataIndex: 'ytPrice',
            //             editable: true,
            //             render: (text: any) => text === "null" ? "" : `￥${formatNum(text)}`,
            //         }, {
            //             title: '云泰总价',
            //             width: 160,
            //             dataIndex: 'ytAmount',
            //             editable: true,
            //             render: (text: any) => `￥${formatNum(text)}`,
            //         },
            //     ] : []
            // }(formVal.isMiddleman)),
            // {
            title: '外贸单价',
            width: 160,
            dataIndex: 'tradePrice',
            editable: true,
            render: (text: any) => text === "null" ? "" : `${getcurrencySymbol(mode)} ${formatNum(text)}`,
        }, {
            title: '外贸总价',
            width: 160,
            dataIndex: 'tradeAmount',
            // editable: true,
            render: (text: any) => `${getcurrencySymbol(mode)} ${formatNum(text)}`,
        },
        {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            editable: true,
        }
    ];

    const newColumn = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                //最后一行合计不可以编辑
                editable: record.key === "totalAmount" ? false : col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: IOfferMaterialDetail) => {
        let dataSource = [...tableList];
        const index = dataSource.findIndex((item) => row.key === item.key);
        const item = dataSource[index];

        let { auhowPrice, upPrice, drawbackAmount, ytPrice, exchangeRate, isMiddleman } = formVal;  //主单维护的所有单价上浮
        let num: number = +formatInt(row.num);
        let price: number = +formatNum(row.price); //采购单价
        //判断（数量||单价）有变动过 ？ 后面所有单价和总价按照公式重新计算一遍 ： 计算单个模块的
        if (+item.num !== num || +item.price !== price) {
            row.num = num;
            row.price = price;
            // debugger;
            //采购总金额 = 数量 * 单价
            row.amount = +formatNum(num * price);

            // //欧豪销售单价 = 欧豪销售单价=采购单价*1.04
            // row.auhowPrice = +formatNum(price * +auhowPrice);
            // row.auhowAmount = +formatNum(num * +row.auhowPrice);

            // //上浮单价 = 欧豪销售单价 * 1.02
            // row.upPrice = +formatNum(row.auhowPrice * +upPrice);
            // row.upAmount = +formatNum(num * +row.upPrice);

            // //退税金额 = 欧豪销售单价/1.13*0.13
            // row.drawbackAmount = +formatNum(+row.auhowPrice / 1.13 * 0.13);

            // //云湖销售单价 = 上浮单价-退税金额
            // row.salePrice = +formatNum(+row.upPrice - +row.drawbackAmount);
            // row.saleAmount = +formatNum(num * +row.salePrice);

            // //云泰单价=云湖销售单价*1.01
            // //是云泰和国外的国家走外汇，不是每个客户都要走云泰公司的，
            // row.ytPrice = +formatNum(+row.salePrice * +ytPrice);
            // row.ytAmount = +formatNum(num * +row.ytPrice);

            // //外贸价格 = 云湖销售单价（人民币）/ 汇率
            // //外贸价格= 云泰单价÷汇率，如果有云泰单价，那么外贸价格拿云泰单价÷汇率，
            // if (isMiddleman) {
            //     row.tradePrice = +formatNum((row.ytPrice as number) / +(exchangeRate ?? 1));
            //     row.tradeAmount = +formatNum(num * +row.tradePrice);
            // } else {
            //     row.tradePrice = +formatNum((row.salePrice as number) / +(exchangeRate ?? 1));
            //     row.tradeAmount = +formatNum(num * +row.tradePrice);
            // }

        }
        //欧豪单价变动
        if (+item.auhowPrice !== +row.auhowPrice) {
            row.auhowPrice = +formatNum(row.auhowPrice);
            row.auhowAmount = +formatNum(num * +row.auhowPrice);
        }
        //上浮单价变动
        if (+item.upPrice !== +row.upPrice) {
            row.upPrice = +formatNum(row.upPrice);
            row.upAmount = +formatNum(num * +row.upPrice);
        }
        //退税金额变动
        if (+item.drawbackAmount !== +row.drawbackAmount) {
            row.drawbackAmount = +formatNum(row.drawbackAmount);
        }
        //云湖销售单价变动
        if (+item.salePrice !== +row.salePrice) {
            row.salePrice = +formatNum(row.salePrice);
            row.saleAmount = +formatNum(num * +row.salePrice);
        }
        //外贸单价变动
        if (+item.tradePrice !== +row.tradePrice) {
            row.tradePrice = +formatNum(row.tradePrice);
            row.tradeAmount = +formatNum(num * +row.tradePrice);
        }
        //云泰单价变动
        if (+item.ytPrice !== +row.ytPrice) {
            row.ytPrice = +formatNum(row.ytPrice);
            row.ytAmount = +formatNum(num * +row.ytPrice);
        }

        dataSource.splice(index, 1, { ...item, ...row });
        updateList(mode, dataSource);
    }

    const upLoadCallback = async () => {
        await getOfferDetailOneGoods()
    }

    const action = <>
        {/* <YhAuth resCode={ResourceAuthEnum.O_ED_AD_M}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { setMaterialDialog(true) }}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.O_ED_DEL}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        message.warning("请选择你要删除的商品");
                        return;
                    }
                    removeMaterial(mode, selectedRowKeys)
                }}
            >删除</Button>
        </YhAuth> */}
        <YhAuth resCode={ResourceAuthEnum.O_M_DLOAD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={downloadSupplierTpl}
            >下载导入详情模板</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.O_M_IM}>
            <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig1(offerService.importDetail(formVal.code), upLoadCallback)}>
                <Button className="mr-5" type="link" shape="round">导入</Button>
            </Upload>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.O_M_EX}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => materialExportExcel()}
            >导出</Button>
        </YhAuth>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行排序");
                    return;
                }
                let number = "";
                Modal.confirm({
                    title: "请输入排序数字",
                    content: <>
                        <Input placeholder="请输入排序数字" onChange={(e) => { number = e.target.value }} />
                    </>,
                    okText: '确定',
                    cancelText: '取消',
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            if (number && /^[+-]?\d*\.?\d*$/.test(number)) {
                                resolve(number);
                            } else {
                                message.warning("请输入排序数字");
                                reject('请输入排序数字');
                            }
                        }).then(async (res: any) => {
                            let { retData } = await enquiryService.offerOrderNum({
                                id: selectedRowKeys[0],
                                orderNum: +res
                            })
                            message.success("修改成功")
                        });
                    },
                    onCancel: () => { }
                })
            }}
        >修改顺位</Button>
    </>


    const totalRow = {
        key: "totalAmount",
        totalTxt: "合计:",
        num: desc.numAll,
        amount: desc.amountAll,
        auhowAmount: desc.auhowAmount,
        upAmount: desc.upAmountAll,
        saleAmount: desc.saleAmountAll,
        tradeAmount: desc.tradeAmountAll,
        ytAmount: desc.ytAmountAll,
        price: "null",
        upPrice: "null",
        auhowPrice: "null",
        drawbackAmount: "null",
        salePrice: "null",
        tradePrice: "null",
        ytPrice: "null",

    }

    return (
        <YhBox title=" " style={{ marginBottom: "75px" }} rightChildren={action}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    getCheckboxProps: (record) => {
                        let checkboxProps: any = {};
                        if (record.key === "totalAmount") {
                            checkboxProps.disabled = true;
                        }
                        return checkboxProps;
                    },
                    onChange: (selectedRowKeys: React.Key[], selectedRows: IOfferMaterialDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys.filter(item => item !== "totalAmount") as string[]);
                    }
                }}
                components={isDisabeld(mode)
                    ? {} : {
                        body: {
                            row: EditableRow,
                            cell: EditableCell,
                        },
                    }}
                columns={(isDisabeld(mode) ? columns : newColumn) as ColumnsType<any>}
                dataSource={tableList.length > 0 ? [...tableList, totalRow] : []}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}